import { Dimensions, IsoIntervalStr, Quantity } from '@elderbyte/ngx-starter'
import { AuditedEntity } from '../../audited-entity'
import { IdNumberReference } from '../../common/id-number-reference'
import { Delivery } from '../delivery/delivery'
import { JsonMap, OrderCompletionState } from '../work-orders/work-order'

export class ProdOrder extends AuditedEntity {
  public id: string

  public company: string

  /**
   * facility id
   */
  public facility: string

  /**
   * Timezone of facility
   */
  public facilityZone: string

  public facilityLocked: boolean

  public groupId: string

  public projectId: string
  public projectDescription: string
  public projectSearchTerm: string

  public description: string
  public orderPriority: ProdOrderPriority
  public confirmationState: OrderConfirmationState

  public completionState: OrderCompletionState

  public labels: string[] = []

  public deliveryInterval: IsoIntervalStr
  public shipment: OrderShipment
  public packaging: OrderPackaging
  public deliveries: Delivery[]

  public properties: JsonMap<string> = {}

  public note: string

  constructor() {
    super()
  }
}

export interface OrderShipment {
  readonly deliveryNoteRef: IdNumberReference
}

export enum ProdOrderPriority {
  HIGH = 'HIGH',

  MEDIUM = 'MEDIUM',

  LOW = 'LOW',
}

export interface OrderPackaging {
  readonly maxWeight: Quantity
  readonly maxDimensions: Dimensions
}

export enum OrderConfirmationState {
  /**
   * Open as a new order. It is not cleared for manufacturing.
   */
  OPEN = 'OPEN',

  /**
   * All order items are recorded completely. Can be manufactured.
   */
  CONFIRMED = 'CONFIRMED',

  /**
   * The order has been cancelled.
   */
  CANCELLED = 'CANCELLED',
}

export enum DisplayOrderConfirmationState {
  OPEN = OrderConfirmationState.OPEN,
  CONFIRMED = OrderConfirmationState.CONFIRMED,
}
